import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "image-top-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 2.50024C18.5188 2.50024 19.75 3.73146 19.75 5.25024L19.75 10.2502C19.75 11.769 18.5188 13.0002 17 13.0002H7C5.48122 13.0002 4.25 11.769 4.25 10.2502L4.25 5.25024C4.25 3.73146 5.48122 2.50024 7 2.50024L17 2.50024ZM18.25 5.25024C18.25 4.55989 17.6904 4.00024 17 4.00024L7 4.00024C6.30964 4.00024 5.75 4.55989 5.75 5.25024L5.75 10.2502C5.75 10.9406 6.30964 11.5002 7 11.5002H17C17.6904 11.5002 18.25 10.9406 18.25 10.2502L18.25 5.25024Z"
    }, null, -1),
    _createElementVNode("path", { d: "M4.25 20.75C4.25 20.3358 4.58579 20 5 20H19C19.4142 20 19.75 20.3358 19.75 20.75C19.75 21.1643 19.4142 21.5 19 21.5H5C4.58579 21.5 4.25 21.1642 4.25 20.75Z" }, null, -1),
    _createElementVNode("path", { d: "M5 15.5292C4.58579 15.5292 4.25 15.865 4.25 16.2792C4.25 16.6934 4.58579 17.0292 5 17.0292L19 17.0292C19.4142 17.0292 19.75 16.6934 19.75 16.2792C19.75 15.865 19.4142 15.5292 19 15.5292L5 15.5292Z" }, null, -1)
  ])))
}
export default { render: render }